/** Колонка Тип данных */
export enum FieldType {
  int = 'int',
  str = 'str',
  bool = 'bool',
  datetime = 'datetime',
  enum = 'enum',
  formula = 'formula',
  percent = 'percent',
}
